import * as React from "react";

interface Props {
  name: string;
  className: string;
  value: string;
  onChange: Function;
  disabled?: boolean;
  autoComplete?: string;
  autoFocus?: boolean;
  placeholder?: string;
  feedbackMessage?: string;
}

interface State {
  hidden: boolean;
  value?: string;
}

export class PasswordToggleInput extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true
    };

    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }

  handlePasswordChange(e) {
    this.props.onChange(e);
    this.setState({ value: e.target.value });
  }

  toggleShow(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    this.setState({ hidden: !this.state.hidden });
  }

  componentDidMount() {
    if (this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    return (
      <div className="password-toggle-input">
        <input
          value={this.state.value}
          type={this.state.hidden ? 'password' : 'text'}
          onChange={this.handlePasswordChange}
          name={this.props.name}
          className={this.props.className}
          disabled={this.props.disabled}
          autoComplete={this.props.autoComplete}
          autoFocus={this.props.autoFocus}
          placeholder={this.props.placeholder}
        />
        {!this.props.disabled ?
          <button onClick={(e) => this.toggleShow(e)}>
            {this.state.hidden ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
            </button>
          : null}
        {this.props.feedbackMessage ?
          <div className="invalid-feedback">{this.props.feedbackMessage}</div>
          : null }
      </div>
    );
  }
}
